/**
 * Deferred Hydration — Interaction-Gated Tier (performance-system spec)
 *
 * Canonical template-clone pattern: a <template> element holds deferred content,
 * cloned via content.cloneNode(true) into the target container on first user
 * interaction (pointerdown, keydown, touchstart, mousedown) or after 45s timeout.
 *
 * All new deferred modules SHOULD follow this same pattern.
 * See: openspec/specs/performance-system/spec.md
 */
(function () {
  var activated = false;

  function activatePaymentButtons() {
    if (activated) return;
    activated = true;
    document.querySelectorAll('[data-lazy-payment-button]').forEach(function (container) {
      var template = document.getElementById(container.getAttribute('data-template-id'));
      if (!template) return;
      container.appendChild(template.content.cloneNode(true));
      container.removeAttribute('data-lazy-payment-button');
      template.remove();
    });
  }

  var events = ['pointerdown', 'keydown', 'touchstart', 'mousedown'];
  for (var i = 0; i < events.length; i++) {
    window.addEventListener(events[i], activatePaymentButtons, { once: true, passive: true });
  }

  window.addEventListener(
    'load',
    function () {
      setTimeout(activatePaymentButtons, 45000);
    },
    { once: true }
  );
})();
